import React from 'react';

export default function NotFound() {
  return (
    <div>
      <h1>Access Denied</h1>
    </div>
  );
}
